interface Props {
  secondsLeft: number;
  onStaySignedIn: () => void;
  onSignOut: () => void;
}

export default function SessionTimeoutModal({ secondsLeft, onStaySignedIn, onSignOut }: Props) {
  const minutes = Math.floor(secondsLeft / 60);
  const secs = secondsLeft % 60;
  const timeStr = minutes > 0
    ? `${minutes}:${String(secs).padStart(2, '0')}`
    : `${secs}s`;

  return (
    <div className="session-timeout-overlay" role="dialog" aria-modal="true" aria-labelledby="timeout-title">
      <div className="session-timeout-modal">
        <h2 id="timeout-title" className="session-timeout-modal__title">Session expiring soon</h2>
        <p className="session-timeout-modal__body">
          You've been inactive for a while. Your session will expire in{' '}
          <strong className="session-timeout-modal__countdown">{timeStr}</strong>.
        </p>
        <div className="session-timeout-modal__actions">
          <button className="btn btn--primary" onClick={onStaySignedIn}>
            Stay signed in
          </button>
          <button className="btn btn--ghost" onClick={onSignOut}>
            Sign out
          </button>
        </div>
      </div>
    </div>
  );
}
